<template>
  <g>xxxx</g>
</template>

<script>
import * as d3plus from 'd3plus-text'

export default {
  props: {
    label: [String, Number],
    parent: Object,
    fontSize: {
      type: Number,
      default: () => 12,
    },
    fontMax: {
      type: Number,
      default: () => 12,
    },
    fontWeight: {
      type: String,
      default: () => 'bold',
    },
    font: {
      type: String,
      default: () => 'Poppins, Helvetica neue, Helvetica'
    },
    width: {
      type: Number,
      default: () => 200,
    },
    height: {
      type: Number,
      default: () => 100,
    },
    x: {
      type: [Number, String],
      default: () => 0,
    },
    y: {
      type: Number,
      default: () => 0,
    },
    verticalAlign: {
      type: String,
      default: () => 'top',
    },
    align: {
      type: String,
      default: () => 'start',
    },
    color: {
      type: String,
      default: () => '#000000'
    },
  },
  methods:{
    displayLabels(){
      new d3plus.TextBox()
        .select(this.$el)
        .data([{ text: this.label }])
        .fontSize( () => this.fontSize)
        .fontMax( () => this.fontMax)
        .fontMin(2)
        .fontWeight(this.fontWeight)
        // .fontFamily('Helvetica')
        .width( () => this.width)
        .height( () => this.height)
        .x( () => this.x)
        .y( () => this.y)
        .textAnchor( () => this.align)
        .verticalAlign( () => this.verticalAlign)
        .fontResize(true)
        .fontColor( () => this.color)
        .render()
    },
  },
  watch:{
    label(){
      this.displayLabels()
    }
  },
  mounted(){
    this.displayLabels()
  },
}
</script>
